/** @jsxImportSource @emotion/react */
import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { CardBody } from "../../components/page-skeleton/CardBody";
import { css } from "@emotion/react";
import { SpinnerBlock } from "../common/Spinner";
import { EmptyState } from "../../components/EmptyState";
import { Divider } from "../../components/Divider";
import { useListPaymentProviderConfigurations } from "./service/payment-provider-configrations-api";
import { MutatePaymentProviderConfigurationSelector } from "./components/MutatePaymentProviderConfigurationSelector";
import { PaymentProvidersConfigurationsTable } from "./components/PaymentProvidersConfigurationsTable";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

export const PaymentProviderConfigurations = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data, isLoading } = useListPaymentProviderConfigurations(
    organizationKeyName
  );

  if (isLoading || !data) {
    return <SpinnerBlock />;
  }

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Payment provider configurations"
          subtitle="Manage all of your payment provider configurations"
        >
          <MutatePaymentProviderConfigurationSelector
            existingPaymentProviders={data.map(
              (paymentProviderConfiguration) =>
                paymentProviderConfiguration.provider
            )}
          />
        </PageHeader>
        {data?.length === 0 || !data ? (
          <>
            <Divider />
            <CardBody additionalStyles={cardBodyAdditionalStyling}>
              <EmptyState
                title="No payment provider configurations created yet"
                subtitle="Create your first payment provider configuration by pressing on create payment provider configuration in top right corner"
              />
            </CardBody>
          </>
        ) : (
          <PaymentProvidersConfigurationsTable
            paymentProviderConfigurations={data}
          />
        )}
      </CardContainer>
    </PageWrapper>
  );
};
